import React, { useMemo, useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify'; 
import { getAllowedPaths, isPathAllowed, getDefaultRoute } from '../Utils/permissionUtils';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // Prioritize localStorage for persistence across tabs/refreshes
  const userDataStr = localStorage.getItem('user') || sessionStorage.getItem('user');
  const userType = localStorage.getItem("userType") || sessionStorage.getItem("userType");
  const token = localStorage.getItem('token') || localStorage.getItem('commonToken') || 
                sessionStorage.getItem('token') || sessionStorage.getItem('commonToken');

  const allowedPaths = useMemo(() => {
    let menus = [];
    if (userDataStr) {
        try {
            const user = JSON.parse(userDataStr);
            menus = user.menus || [];
        } catch (e) {
            console.error("Error parsing user data for permissions", e);
        }
    }
    return getAllowedPaths(menus, userType);
  }, [userDataStr, userType]);

  const defaultPath = useMemo(() => {
    let menus = [];
    if (userDataStr) {
        try {
            const user = JSON.parse(userDataStr);
            menus = user.menus || [];
        } catch (e) {
            menus = [];
        }
    }
    return getDefaultRoute(menus, userType);
  }, [userDataStr, userType]);

  const isAllowed = isPathAllowed(location.pathname, allowedPaths);

  useEffect(() => {
    if (!token) {
        // No token, toast and redirect happens via render
        toast.error("Session expired. Please login.");
    } else if (!isAllowed && location.pathname !== defaultPath) {
        toast.error("You are unauthorized for this page. Please check login");
    }
  }, [token, isAllowed, location.pathname, defaultPath]);

  // If not authenticated, redirect to login
  if (!token) {
      return <Navigate to="/" replace />;
  }

  // If authenticated but not allowed
  if (!isAllowed) {
     // Redirect to the default allowed path
     if (location.pathname !== defaultPath) {
         return <Navigate to={defaultPath} replace />;
     } else {
         // Fallback if they are somehow on the default path but still not allowed (e.g. empty menu?)
         return (
             <div style={{ padding: '20px', textAlign: 'center' }}>
                 <h1>Access Denied</h1>
                 <p>You do not have permission to view this page.</p>
             </div>
         );
     }
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
